import { render, staticRenderFns } from "./TopicModelTry.vue?vue&type=template&id=90692948&"
import script from "./TopicModelTry.vue?vue&type=script&lang=js&"
export * from "./TopicModelTry.vue?vue&type=script&lang=js&"
import style0 from "./TopicModelTry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports